<template>
  <div>
    <form data-vv-scope="form-group">
      <b-form-group
        label="Selecciona la oficina de la que deseas asignar el expediente"
      >
        <SelectValidate
          v-model="groupSelected"
          :options="userCompanyGroups"
          name="office"
          data-cy="select-offices"
          v-validate="'required'"
          :danger="errors.has('form-group.office')"
          :danger-text="errors.first('form-group.office')"
          data-vv-as="oficina"
          :state="errors.has('form-group.office') ? false : null"
        />
      </b-form-group>
    </form>
    <div class="text-right mt-2">
      <b-button
        class="mr-2"
        data-cy="search-flows-button"
        variant="primary"
        size="sm"
        @click="$emit('search-flows-office', groupSelected)"
      >
        Buscar expedientes de oficina
      </b-button>
    </div>
  </div>
</template>
<script>

import SelectValidate from '@/febos/chile/_vue/componentes/SelectValidate';

export default {
  components: {
    SelectValidate
  },
  data() {
    return {
      groupSelected: ''
    };
  },
  computed: {

  },
  methods: {
  },
  props: {
    userCompanyGroups: { type: Array }
  }
};
</script>
